/* 🤖 this file was generated by svg-to-ts */
export const DfIconImagePlus16: {
  name: 'image-plus-16';
  data: string;
} = {
  name: 'image-plus-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7 1h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V8a5 5 0 0 0 7-7zm5 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-4.418 4.918-2.233-1.81a.5.5 0 0 0-.627-.002l-2.508 2.003a.5.5 0 0 0 .313.891h4.979a.5.5 0 0 0 .09-.008c.028.005.059.008.09.008h6.676a.5.5 0 0 0 .334-.872l-3.36-3.013a.5.5 0 0 0-.67.003zM2 3V2a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2H4v1a1 1 0 1 1-2 0V5H1a1 1 0 1 1 0-2z" fill-rule="evenodd"/></svg>`
};
